import {
  createNaturalDivisionRemainderTask,
  randInt,
  remainderDivisionExplanation,
} from "./sharedNaturalDivision";

function pickData() {
  for (let i = 0; i < 300; i += 1) {
    const b = randInt(3, 9);
    const quotient = randInt(10, 29);
    const remainder = randInt(1, b - 1);
    const product = quotient * b;
    const a = product + remainder;
    if (a >= 30 && a <= 99) return { a, b, quotient, remainder, product };
  }
  return { a: 47, b: 3, quotient: 15, remainder: 2, product: 45 };
}

const mod = createNaturalDivisionRemainderTask({
  type: "NaturalDivRemainderTwoDigitTask",
  pickData,
  explain: remainderDivisionExplanation,
});

export const generateTask = mod.generateTask;
export const renderTask = mod.renderTask;
export const renderInput = mod.renderInput;
export const checkAnswer = mod.checkAnswer;
export const renderAnswer = mod.renderAnswer;
export const renderUserAnswer = mod.renderUserAnswer;
export const renderExplanation = mod.renderExplanation;
